import { Country } from '../constants/country';
import { defaultCountries, otherCountry } from '../constants/countryData';

const isCountry = (value: string): value is Country => Object.values<string>(Country).includes(value);

const getProvinceStateFieldText = (country: Country | string, placeholder = false) => {
  switch (country) {
    case Country.US:
    case Country.MX:
      return 'State';
    case Country.CA:
      return 'Province';
    default:
      return placeholder ? 'item' : 'Province, State, Region';
  }
};

const getCountryRequiredFields = (country: Country | string) =>
  isCountry(country) && defaultCountries.includes(country as Country) ? ['state', 'zipCode'] : ['state'];

const getPostalZipFieldLength = (country: Country | string) => {
  switch (country) {
    case Country.US:
    case Country.MX:
      return 5;
    case Country.CA:
    case Country.Other:
      return 6;
    default:
      return 8;
  }
};

const getCountryFieldData = (country: Country | string) => {
  const isValidCountry = country && country !== '' && country !== otherCountry.value;

  const isOther = country === Country.Other;

  const isUS = country === Country.US;

  const isMexico = country === Country.MX;

  const postalZipFieldText = isUS ? 'zip' : 'postal';

  const postalZipFieldTextAsterisk = isCountry(country) && defaultCountries.includes(country as Country) ? '*' : '';

  const provinceStateFieldText = getProvinceStateFieldText(country);

  const provinceStateFieldPlaceholder = getProvinceStateFieldText(country, true);

  const postalZipFieldLength = getPostalZipFieldLength(country);

  return {
    isCountry: isValidCountry,
    isOther,
    isUS,
    isMexico,
    postalZipFieldText,
    postalZipFieldLength,
    postalZipFieldTextAsterisk,
    provinceStateFieldText,
    provinceStateFieldPlaceholder,
  };
};

export { getCountryRequiredFields, getCountryFieldData, isCountry };
